import React from 'react';
import { StyledTBody } from './Table.styled';
export function TBody(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledTBody, null, children);
}